import {ArrowPrev} from '@/_application/icons';
import cn from 'classnames';

interface Props {
    onClick: () => void;
    className?: string;
}

const PreviousButton = ({onClick, className}: Props) => {
    return (
        <button
            aria-label="Slide trước"
            className={cn('flex items-center text-primary', className)}
            onClick={onClick}>
            <ArrowPrev className="h-4 w-4" />
        </button>
    );
};

export default PreviousButton;
